import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { newPath } from "../../../components/utilities/UtilityFunctions";
import { postNotification } from "../../../components/utilities/Notifications";
import ModalLoadingFull from "../../../components/modals/ModalLoadingFull";

import { EventSoftScorePlayerEntry } from "./SubComponents/EventSoftScoreComponents";

export default function EventPlayerSoftScores(props) {
  const { activeTab, setActiveTab, event } = props;
  const navigate = useNavigate();

  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventSoftScores"
  });

  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        if (!event?.player) {
          postNotification("warning", t("notActivePlayer"));
          let path = newPath({
            active_tab: "overview",
          });
          setActiveTab(0);
          navigate(path, { replace: false });
          return;
        }
        if (!event?.softScores?.filter((el) => el.playerScored)) {
          postNotification("warning", t("noPlayerScoredSoftScores"));
          let path = newPath({
            active_tab: "overview",
          });
          setActiveTab(0);
          navigate(path, { replace: false });
          return;
        }

        setPlayer(event.player);
      } catch (err) {
        postNotification("error", err);
      }
      setLoading(false);
    };
    check();
    // eslint-disable-next-line
  }, [activeTab, event]);

  return (
    <>
      {player && (
        <EventSoftScorePlayerEntry
          event={event}
          player={player}
          setPlayer={setPlayer}
          activeRound={event.currentRound}
        />
      )}
      {loading && <ModalLoadingFull />}
    </>
  );
}
